const doc = [({"en":({"js":({"admin":({"highscores":({"nav":({"communes":"Communes", "generations":"Generations", "regions":"Regions"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;